@if (!authenticated()) {
  <div class="flex items-center gap-2">
    <app-language-dropdown></app-language-dropdown>

    <p-button
      data-testid="login-button"
      label="{{ 'common.login' | transloco }}"
      severity="contrast"
      variant="outlined"
      (onClick)="login()"
    />

    <p-button
      data-testid="signup-button"
      label="{{ 'header.signUp' | transloco }}"
      routerLink="{{ APP_ROUTES.REGISTRATION }}"
    />
  </div>
} @else {
  <div class="flex items-center h-9">
    <p-menubar
      [model]="items()"
      [style]="{'min-width': '100px'}"
      styleClass="user-profile-menu"
      data-testid="profile-menubar"
    />
  </div>
}
